import { detect } from 'detect-browser'

export default function ({ store }) {
  const data = detect()
  console.info({ browser: data })

  store.commit('setBrowser', data)
}
